// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "form[data-v-44703583] {\n    margin-bottom: 15px;\n}\n.form-group[data-v-44703583] {\n    margin-right: 16px;\n    margin-bottom: 10px;\n}\nform label[data-v-44703583] {\n    margin-right: 4px;\n    margin-left: 5px;\n}\n@media only screen and (min-width: 768px) {\n.vdp-datepicker[data-v-44703583] {\n        display: inline-block;\n}\n}", ""]);
// Exports
module.exports = exports;
